<template>
    <b-modal
        id="importMany"
        title="Importar Alunos em Massa"
        hide-footer
    >
        <b-overlay :show="loading" rounded="sm">

            <!-- Model -->
            <b-alert :show="true" variant="info">
                Primeiramente você precisa baixar o modelo de planilha para importar seus alunos por turma. Você encontra o link abaixo: <br>

                <a v-if="matriculation" href="/import/modelo-matricula.xlsx" target="_blank" class="btn btn-info mt-2 mb-2">
                    <i class="fas fa-file-download mr-1"></i>
                    Baixar Modelo de Planilha
                </a>

                <a v-else href="/import/modelo.xlsx" target="_blank" class="btn btn-info mt-2 mb-2">
                    <i class="fas fa-file-download mr-1"></i>
                    Baixar Modelo de Planilha
                </a>

            </b-alert>

            <!-- Field -->
            <b-form-group
                label="Turma"
                description="Qual a turma que os alunos da sua importação irão pertencer ?">

                <multiselect
                    v-model="form.group"
                    :options="groupsOptions"
                    :loading="loading"
                    track-by="id"
                    label="name"
                    placeholder="Buscar por Turma ..."
                    tag-placeholder="Filtrar Turma"
                    selectLabel="Selecionar"
                    deselectLabel="Desmarcar"
                    selectedLabel="Selecionado">

                        <span slot="noResult">
                            Ops! Nenhum resultado encontrado na pesquisa :(
                        </span>

                        <span slot="noOptions">
                            Não há turmas disponíveis para exibir :(
                        </span>

                </multiselect>
            </b-form-group>

            <!-- Field -->
            <b-form-group
                label="Arquivo de Importação"
                description="Depois de preencher a planilha de acordo com o modelo acima, você insere o arquivo para importar">

                <!-- Input -->
                <b-form-file
                    ref="file"
                    @input="loadFile"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    placeholder=""
                    browse-text="Procurar"
                    no-drop
                ></b-form-file>

            </b-form-group>

            <b-form-group>
                <b-button type="button" variant="primary" @click="submit" :disabled="loading">
                    Importar Alunos
                </b-button>
            </b-form-group>

        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['groupsOptions', 'matriculation'],
    data() {
        return {
            loading: false,
            form: {
                group: null,
                archive: null,
            },
        }
    },
    created() {

        this.$root.$on('importMany', () => {
            this.$bvModal.show('importMany')
        })

    },
    methods: {

        submit() {
            this.loading = true;

            let formData = new FormData();

            formData.append('archive', this.form.archive)
            formData.append('group_id', this.form.group ? this.form.group.id : null);

            axios.post('/teacher/students/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {

                    // Load
                    this.$emit('imported')

                    // Message
                    this.$toast.success('Alunos importados com sucesso :)');

                    // Close Modal
                    this.$bvModal.hide('importMany')

                    // Clear Form
                    this.form = {
                        group: null,
                        archive: null,
                    }

                })
                .finally(() => this.loading = false)
        },

        loadFile() {
            if (this.$refs.file.files[0]) {
                this.form.archive = this.$refs.file.files[0]
            } else {
                this.form.archive = null;
            }
        }

    }
}
</script>

<style scoped>

</style>
